if (!customElements.get('mouseover-zoom')) {
    customElements.define(
        'mouseover-zoom',
        class MouseoverZoom extends HTMLElement {
            constructor() {
                super();
                this.zoomContent         = null;
                this.zoomScale           = 2;
                this.isZooming           = false;                                      // State to activate/deactivate zoom (mobile only)
                this.isMobile            = /Mobi|Android/i.test(navigator.userAgent);  // Detect mobile devices
                this.handleMouseMove     = this.handleMouseMove.bind(this);
                this.handleMouseLeave    = this.handleMouseLeave.bind(this);
                this.handleTouchStart    = this.handleTouchStart.bind(this);
                this.handleTouchMove     = this.handleTouchMove.bind(this);
                this.handleDocumentClick = this.handleDocumentClick.bind(this);
            }

            connectedCallback() {
                this.zoomContent = this.querySelector('img, video, svg');
                if (!this.zoomContent) return;
                if (this.isMobile) {
                    // Mobile devices events
                    this.addEventListener('click', this.handleTouchStart);
                    this.addEventListener('touchmove', this.handleTouchMove);
                    document.addEventListener('touchstart', this.handleDocumentClick);
                } else {
                    // Desktop devices events
                    this.addEventListener('mousemove', this.handleMouseMove);
                    this.addEventListener('mouseleave', this.handleMouseLeave);
                }
            }

            disconnectedCallback() {
                if (!this.zoomContent) return;
                if (this.isMobile) {
                    // Mobile devices events
                    this.removeEventListener('touchstart', this.handleTouchStart);
                    this.removeEventListener('touchmove', this.handleTouchMove);
                    document.removeEventListener('touchstart', this.handleDocumentClick);
                } else {
                    // Desktop devices events
                    this.removeEventListener('mousemove', this.handleMouseMove);
                    this.removeEventListener('mouseleave', this.handleMouseLeave);
                }
            }


            /*
                Event handler for desktop mousemove event to zoom content
            */
            handleMouseMove(event) {
                if (!this.zoomContent) return;
                if (!this.isZooming) {
                    this.isZooming = true;
                    this.activateBackgroundOverlay();
                }
                const rect     = this.getBoundingClientRect();
                const offsetX  = ((event.clientX - rect.left) / rect.width - 0.5) * 100 * -1;
                const offsetY  = ((event.clientY - rect.top) / rect.height - 0.5) * 100 * -1;

                this.zoomContent.style.transform = `scale(${this.zoomScale}) translate(${offsetX.toFixed(2)}%, ${offsetY.toFixed(2)}%)`;
            }

            /*
                Setup background overlay
            */
            activateBackgroundOverlay() {
                document.body.classList.add("fg-mouseover-zoomed");
                document.body.style.overflow = 'hidden';
            }

            /*
                Event handler for desktop mouseleave event to reset zoom content
            */
            handleMouseLeave() {
                if (this.zoomContent) {
                    this.zoomContent.style.transform = 'scale(1) translate(0, 0)';
                    this.isZooming = false;
                    this.deactivateBackgroundOverlay();
                }
            }

            /*
                Deactivate background overlay
            */
            deactivateBackgroundOverlay() {
                document.body.classList.remove("fg-mouseover-zoomed");
                document.body.style.overflow = '';
            }

            /*
                Event handler for mobile touchstart event to activate zoom state
            */
            handleTouchStart() {
                if (!this.zoomContent) return;

                if (!this.isZooming) {
                    this.isZooming = true;
                    this.zoomContent.style.transition = ''; // Remove smooth transition for instant updates
                    this.zoomContent.style.transform = `scale(${this.zoomScale}) translate(0, 0)`;
                    this.activateBackgroundOverlay();
                }
            }

            /*
                Event handler for mobile touchmove event to zoom content
            */
            handleTouchMove(event) {
                if (!this.isZooming || !this.zoomContent || event.touches.length === 0) return;

                const touch   = event.touches[event.touches.length - 1];
                const rect    = this.getBoundingClientRect();
                const offsetX = - ((touch.clientX - rect.left) / rect.width - 0.5) * 100 * -1;
                const offsetY = - ((touch.clientY - rect.top) / rect.height - 0.5) * 100 * -1;

                // Update transform directly without throttling
                this.zoomContent.style.transform = `scale(${this.zoomScale}) translate(${offsetX.toFixed(2)}%, ${offsetY.toFixed(2)}%)`;

                event.preventDefault(); // Prevent scrolling while zooming
            }

            /*
                Event handler for mobile touch outside event to deactivate zoom state
            */
            handleDocumentClick(event) {
                if (!this.isZooming) return;

                if (!this.contains(event.target)) {
                    this.isZooming = false;

                    if (this.zoomContent) {
                        this.zoomContent.style.transform = 'scale(1) translate(0, 0)';
                        this.deactivateBackgroundOverlay();
                    }
                }
            }
        }
    );
}
